import { AbstractDocument, Identifiable, Timestampable } from '../../abstract/Document';
import { AbstractCollection } from '../../abstract/Collection';
import type { WithFieldValue } from 'firebase/firestore';
import { Identified, PartialMaybe, Timestamped } from '../../abstract/_';
import type { ISupplierCalendar } from './Calendars.types';
import { Supplier } from '../Suppliers';
import { Events } from './Calendars/Events';
import { Schedules } from './Calendars/Schedules';

@Identifiable
@Timestampable
export class Calendar extends AbstractDocument<ISupplierCalendar> {
  readonly collections = {
    Events: new Events(this),
    Schedules: new Schedules(this),
  };

  /**
   * Returns the parent Supplier of this Calendar
   */
  get supplier() {
    return this.reference.parent.parent!.id;
  }
}

export class Calendars extends AbstractCollection<Calendar, ISupplierCalendar> {
  static path = 'calendars';

  constructor(document: Supplier) {
    super(document.collection(Calendars.path), Calendar);
  }

  /**
   * Returns the parent Supplier of this Calendars collection
   */
  get supplier() {
    return this.reference.parent!.id;
  }

  /**
   * Creates a new calendar
   *
   * @param data Object containing calendar creation parameters
   */
  async create(data: WithFieldValue<PartialMaybe<ISupplierCalendar, Identified & Timestamped>>): Promise<Calendar> {
    return await this.push().create(data as ISupplierCalendar);
  }
}
